export const titleMapper = new Map([
  ['reward_earned', 'settings.notificationSettings.settingsTitle.earnReward'],
  ['reward_unused', 'settings.notificationSettings.settingsTitle.unusedReward'],
  ['reward_offer', 'settings.notificationSettings.settingsTitle.newOffer'],
  ['marketing_general', 'settings.notificationSettings.settingsTitle.newsAndUpdates'],
]);
